/** The enum comes back as an object, never a bare string: the logic reads `.value`, the screen reads `.label`. */
export type AiProviderKindPayload = {
	readonly value: string;
	readonly label: string;
};

// `apiKey` never appears on the wire, on any response: the key is replaced, never re-read, not even
// partially. `apiKeyRegisteredAt` is the only proof a key is registered.
export type AiProviderPayload = {
	readonly id: number;
	readonly label: string;
	readonly kind: AiProviderKindPayload;
	readonly baseUrl: string;
	readonly apiVersion: string | null;
	readonly apiKeyRegisteredAt: string;
	readonly isPlatformCredential: boolean;
	readonly lastTestedAt: string | null;
	readonly lastTestSucceeded: boolean | null;
	readonly lastTestMessage: string | null;
	// `null` means the provider has never been tested; `[]` means it was tested and reported no model.
	readonly lastTestModels: string[] | null;
	readonly account: { readonly id: number };
};

export type AiProvidersFetchedPayload = AiProviderPayload[];

export type AiProvidersFetchedAction = {
	type: 'AI_PROVIDERS_FETCHED';
	payload: AiProvidersFetchedPayload;
	accountId: number;
};

export default (payload: AiProvidersFetchedPayload, accountId: number): AiProvidersFetchedAction => ({
	type: 'AI_PROVIDERS_FETCHED',
	payload,
	accountId,
});
